import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../styles/CustomModal.css";
import { ExceedType } from "../../recoil/exceed";
import moment from "moment";

const ExceedModal = (oProps: {
  isVisible: ExceedType;
  setVisible: any;
  onConfirm: any;
}) => {
  const onCloseModal = () => {
    oProps.setVisible({ ...oProps.isVisible, isOpen: false });
  };

  return (
    <Modal
      open={oProps.isVisible.isOpen}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "exceedModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />
          <img
            className="warning"
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_warning.svg`}
            alt="warning"
          />
          {oProps.isVisible.hotel_name && (
            <div className="row">
              <h4>주문 호텔:</h4>
              <span>{`${oProps.isVisible.hotel_name}`}</span>
            </div>
          )}
          <div className="row">
            <h4>주문 시간:</h4>
            <span>{`${moment(oProps.isVisible.ordered_at).format(
              "HH:mm"
            )}`}</span>
          </div>
          <div className="row">
            <h4>배달 예상시간:</h4>
            <span>{`${moment(oProps.isVisible.delivery_expected_at).format(
              "HH:mm"
            )}`}</span>
          </div>
          <h3>
            {"배달 예상시간을 초과한 주문이 있어요!\n서둘러 확인해주세요"}
          </h3>
          <div className="bottomButtonWrap">
            <div className="confirmButton" onClick={oProps.onConfirm}>
              배달 현황 확인하러 가기
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ExceedModal;

const Style = styled.div`
  .modal {
    width: 100%;
    text-align: center;
    padding-top: 20px;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  img.warning {
    height: 40px;
    margin-bottom: 20px;
  }

  .row {
    padding-left: 18%;
    display: flex;
    align-items: center;
  }

  h3 {
    padding: 30px 0;
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;
    color: #555555;
  }

  h4 {
    font-size: 18px;
    line-height: 32px;
    font-weight: 400;
    color: #555555;
    text-align: center;
    width: 120px;
  }

  span {
    font-size: 20px;
    font-weight: 600;
    color: #555555;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;

    .confirmButton {
      width: 100%;
      padding: 14px;
      font-size: 24px;
      line-height: 28px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
